// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"jX-z","inlineTitle":"kX-z","sponsoredAdsWrapper":"lX-z","marketplaceRecosWrapper":"mX-z"};